import React, { useEffect, useState } from "react";
import BreadCrumbs from "../../components/breadcrumbs";
import Banner from "../../components/img_bannerblogs";
import RCMcy from "../../images/BlogCardImgs/BlackandWhiteModernTechnologyPresentation.jpg";
import BlogImg7 from "../../images/BlogCardImgs/obtainingmedicalbillingservicesfromthebestmedical1.webp";
import BlogImg2 from "../../images/BlogCardImgs/choosingtooutsourceyourmedicalbillingisasmartdecision1.webp";
import BlogImg15 from "../../images/BlogCardImgs/managementofhealthcarerevenuecycle1.webp";
import BlogImg16 from "../../images/BlogCardImgs/detailsaboutpatientsareprotectedbyacer1.webp";
import Blogcontent from "../../img/Blogcontent1/modern trends.jpg";
import { Helmet } from "react-helmet";
import "../../css/testcard.css";
import Tablecontent from "../Blogs/Blogstablecontent";

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText,
  MDBCardBody,
} from "mdb-react-ui-kit";

const About = () => {
  useEffect(() => {
    // change title of page
    document.title = "Medical billing trends 2025";
  }, []);

  // Set Banner Title
  const [BannerTitle, setBannerTitle] = useState({
    title: "Medical Billing Trends",
    subtitle: "",
    img: `url(${RCMcy})`,
  });

  return (
    <>
      <Helmet>
        <style>{`body { overflow-x: hidden; }`}</style>
        <title>Top Medical Billing Trends 2025 | Acer Health Blog</title>
        <meta
          name="description"
          content="Discover the top medical billing trends in 2025—from automation and outsourcing to AI and price transparency—shaping the future of healthcare finance."
        />
        <link
          rel="canonical"
          href="https://acerhealth.com/blog/medical-billing-trends-2025"
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://acerhealth.com/blog/top-medical-billing-trends-2025",
            },
            headline:
              "Top Medical Billing Trends in 2025: Future of Healthcare Finance",
            description:
              "Discover the top medical billing trends shaping healthcare in 2025, including automation, outsourcing, price transparency, and value-based payment models.",
            image:
              "https://acerhealth.com/images/blog/medical-billing-trends-2025.jpg",
            author: {
              "@type": "Organization",
              name: "Acer Health",
              url: "https://acerhealth.com",
            },
            publisher: {
              "@type": "Organization",
              name: "Acer Health",
              logo: "%PUBLIC_URL%/favicon.png"
            },
            datePublished: "2025-04-17",
            dateModified: "2025-04-17",
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is automation in medical billing?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Automation in medical billing refers to using software and AI tools like RPA to handle data entry, coding, and claims processing with higher accuracy and speed.",
                },
              },
              {
                "@type": "Question",
                name: "Why are healthcare providers outsourcing billing?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Outsourcing billing gives providers access to specialized expertise, improves scalability, and allows them to focus more on patient care.",
                },
              },
              {
                "@type": "Question",
                name: "Why is price transparency important in healthcare billing?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Price transparency builds trust, empowers patients, and helps providers meet CMS compliance by clearly sharing costs and service pricing.",
                },
              },
              {
                "@type": "Question",
                name: "What are value-based payment models?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "These models link provider reimbursements to patient outcomes rather than volume, encouraging coordinated and high-quality care.",
                },
              },
            ],
          })}
        </script>
      </Helmet>

      <div>
        <Banner BannerTitle={BannerTitle} />
        <div className="container mb-4 mt-4 d-flex">
          <div style={{ maxWidth: "fit-content", width: "fit-content" }}>
            <BreadCrumbs
              paths={[
                { name: "Home", link: "/" },
                { name: "Blogs", link: "/medical-billing-blogs" },
                { name: "Medical Billing Trends 2025" },
              ]}
            />
          </div>
        </div>
        <div className="row" style={{ paddingRight: "10%", paddingLeft: "5%" }}>
          <MDBCol md="3" className="toc-sticky">
            <Tablecontent />
          </MDBCol>

          <MDBCol md="7" className="content" style={{ paddingRight: "50px" }}>
            <h1
              style={{
                textAlign: "center",
                fontSize: "30px",
                fontFamily: "Alegreya Sans",
              }}
              className="mb-4"
            >
              <b>
                Top Medical Billing Trends in 2025: Future of Healthcare Finance
              </b>
            </h1>
            <p
              className=""
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              In 2025, the healthcare industry is growing rapidly, and alongside
              this, medical billing practices are undergoing essential
              transformations. Rising patient expectations,{" "}
              <b>technological advancements</b> like{" "}
              <b>AI in medical Billing</b>, and regulatory improvements have
              come together to reshape how providers handle billing. Here’s a
              deep dive into the top four <b>medical billing trends</b> shaping
              the landscape this year—and how they’re improving both operational
              efficiency and patient satisfaction.
            </p>
            <h2 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
              <b>1. Automation of Billing Processes</b>
            </h2>
            <p
              className=""
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              Imagine trying to calculate your taxes every year, a process that
              is not only complicated but also prone to numerous mistakes and
              quite exhausting. Now, imagine being able to perform the entire
              task with the help of smart software. This is exactly what's
              happening in the world of{" "}
              <a
                href="/blog/choosing_to_outsource_your_medical_billing_is_a_smart_decision"
                style={{ textDecoration: "underline" }}
              >
                medical billing
              </a>{" "}
              today.
            </p>
            <h3
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              <b>Why It Holds Significance:</b>
            </h3>


            <ul>
              <li>
                <h4
                  style={{
                    fontSize: "18px",
                    fontFamily: "Alegreya Sans",
                    fontWeight: "500",
                    // margin: 0, // Optional: prevents extra spacing
                  }}
                >
                  <b>Speed and Accuracy:</b> Automation tools improve data entry,
                  coding, <b>claim submission</b>, and <b>denial management.</b>
                </h4>
              </li>

              <li>
                <h4
                  style={{
                    fontSize: "18px",
                    fontFamily: "Alegreya Sans",
                    fontWeight: "500",
                    // margin: 0, // Optional: prevents extra spacing
                  }}
                >
                  <b>Reduce Human Errors:</b> Algorithms help minimize errors in
                  coding and claims.{" "}
                </h4>
              </li>

              <li>
                <h4
                  style={{
                    fontSize: "18px",
                    fontFamily: "Alegreya Sans",
                    fontWeight: "500",
                   
                  }}
                >
                  <b>Faster Reimbursements:</b> with robotic process automation in
                  healthcare (RPA) and <b>AI in medical billing</b>, claims get
                  processed more quickly and successfully.
                </h4>
              </li>
            </ul>


            <h3
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              <b>Example:</b>
            </h3>
            <p
              className=""
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              A large hospital implemented robotic process automation (RPA) for
              claim submissions, cutting processing time by 50% and increasing
              reimbursements by 25%. This innovation is key to effective{" "}
              <b>revenue cycle management</b> in 2025.
            </p>
            <div className="mb-3">
              <img
                src={Blogcontent}
                alt="AcreHealth medical Billing techniques"
                className="img-fluid"
                width={500}
                height={500}
              />
            </div>

            <h2 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
              <b>2. Increase in Outsourcing</b>
            </h2>
            <p
              className=""
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              Healthcare providers are outsourcing their billing processes to
              third-party experts, not just to cutting costs but also to improve
              performance.
            </p>
            <h3
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              <b>Why It Holds Significance:</b>
            </h3>

            <ul>
              <li>
                <h4 style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                  <b>Access to expertise:</b> Outsourced companies are fully aware
                  of the latest codes, payer rules, and legal compliance.
                </h4>
              </li>
              <li>
                <h4 style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                  <b>Scalability:</b> Healthcare providers can grow without hiring additional staff.
                </h4>
              </li>
              <li>
                <h4 style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                  <b>Better Focus:</b> Healthcare providers can fully concentrate on
                  patient care while outsourced professionals handle the billing.
                </h4>
              </li>
            </ul>

            <h3
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              <b>Example:</b>
            </h3>
            <p
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              A large healthcare network outsourced with{" "}
              <a href="/" style={{ textDecoration: "underline" }}>
                medical billing company
              </a>
              , leading to a 40% decrease in billing errors and a 20% increase
              in revenue cycle efficiency.
            </p>
            <p
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              Read Our Article about{" "}
              <a
                href="/blog/choosing_to_outsource_your_medical_billing_is_a_smart_decision"
                style={{ textDecoration: "underline" }}
              >
                Choosing to Outsource Your Medical Billing is a Smart decision?
              </a>
            </p>

            <h2 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
              <b>3. Focus on Price Transparency</b>
            </h2>
            <p
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              Patients today expect clear and upfront information, particularly
              regarding costs. The days of unclear billing are disappearing as
              transparency becomes not only a legal requirement but also an
              ethical responsibility.
            </p>
            <h3
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              <b>Why It Holds Significance:</b>
            </h3>

            <ul>
              <li>
                <h4 style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                  <b>Patient Empowerment:</b> Patients want clear, upfront
                  information about the cost of services.{" "}
                </h4>
              </li>
              <li>
                <h4 style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                  <b>Trust Building:</b> Transparent billing fosters trust and
                  enhances the overall patient experience, leading to increased
                  satisfaction and long-term loyalty.{" "}
                </h4>
              </li>
              <li>
                <h4 style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                  <b>Regulatory Compliance:</b> The{" "}
                  <a
                    href="https://www.cms.gov/priorities/key-initiatives/hospital-price-transparency"
                    style={{ textDecoration: "underline" }}
                  >
                    CMS Price Transparency Guidelines
                  </a>{" "}
                  mandate that providers publicly share their standard pricing and
                  list of shoppable services to ensure transparency and help
                  patients make informed healthcare decisions.
                </h4>
              </li>
            </ul>





            <h3
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              <b>Example:</b>
            </h3>
            <p
              className=""
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              Hospitals have started implementing online cost calculators,
              enabling patients to estimate out-of-pocket expenses and make more
              informed healthcare decisions.
            </p>
            <p
              className=""
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              <a href="/contact-us" style={{ textDecoration: "underline" }}>
                How Acer Health Supports Pricing Transparency
              </a>
            </p>
            <h2 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
              <b>4. Value-Based Payment Models</b>
            </h2>
            <p
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              Shifting from traditional fee-for-service models,{" "}
              <b>value-based care</b> ties reimbursement to the{" "}
              <b>quality of patient outcomes</b> rather than the{" "}
              <b>volume of services provided.</b>
            </p>
            <h3
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              <b>Why It Holds Significance:</b>
            </h3>

            <ul>
              <li>
                <h4 style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                  <b>Performance-Based Reimbursement:</b> Health providers are
                  incentivized to maintain patient health and meet established care
                  standards, leading to higher reimbursements.
                </h4>
              </li>
              <li>
                <h4 style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                  <b>Data-Driven Billing:</b> Comprehensive patient records are
                  essential to demonstrate the delivery of quality care effectively.
                </h4>
              </li>
              <li>
                <h4 style={{ fontSize: "18px", fontFamily: "Alegreya Sans", fontWeight: "500", }}>
                  <b>Collaboration Incentives:</b> Bundled payment systems encourage
                  providers to work collaboratively, offering coordinated,
                  high-quality care while managing costs efficiently.
                </h4>
              </li>
            </ul>


            <h3
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              <b>Example:</b>
            </h3>
            <p
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              By linking reimbursements to patient recovery rates and overall
              health improvements, healthcare providers have successfully
              reduced costs and enhanced care quality, resulting in substantial
              annual savings. The{" "}
              <a
                href="https://www.cms.gov/priorities/innovation/overview"
                style={{ textDecoration: "Underline" }}
              >
                CMS Innovation Center
              </a>{" "}
              plays a pivotal role in testing and scaling such models, driving
              national efforts to reward smarter, outcome-focused care.
            </p>
            <h2 style={{ fontSize: "25px", fontFamily: "Alegreya Sans" }}>
              <b>Final Thoughts</b>
            </h2>
            <p
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              In 2025, medical billing is no longer just a back-office function;
              it has become a key pillar in delivering modern healthcare. As
              automation streamlines processes, outsourcing expands resources,
              transparency fosters patient confidence, and value-based care
              drives better outcomes, the future of medical billing promises to
              be more efficient, innovative, and focused on the patient
              experience.
            </p>
            <p
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              <a href="/contact-us" style={{ textDecoration: "underline" }}>
                Looking to streamline your billing process? Contact Acer Health
                for a consultation.
              </a>
            </p>
            <h2
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
              }}
            >
              <b>Frequently Asked Questions</b>
            </h2>
            <h3
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
                marginBottom: "5px",
                marginTop: "0px",
              }}
            >
              <b>Q1: Why is automation important in medical billing?</b>
            </h3>
            <p style={{ marginTop: "0px" }}>
              Automation reduces manual errors, speeds up claim submission, and
              ensures quicker reimbursements.
            </p>
            <h3
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
                marginBottom: "5px",
                marginTop: "0px",
              }}
            >
              <b>Q2: How does outsourcing help healthcare providers?</b>
            </h3>
            <p style={{ marginTop: "0px" }}>
              It allows providers to focus on patient care while experts manage
              coding, billing, and compliance efficiently.
            </p>
            <h3
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
                marginBottom: "5px",
                marginTop: "0px",
              }}
            >
              <b>Q3: What is price transparency in healthcare?</b>
            </h3>
            <p style={{ marginTop: "0px" }}>
              It means giving patients clear, upfront details about the cost of
              services, improving trust and informed decisions.
            </p>
            <h3
              style={{
                fontSize: "18px",
                fontFamily: "Alegreya Sans",
                fontWeight: "500",
                marginBottom: "5px",
                marginTop: "0px",
              }}
            >
              <b>Q4: What is value-based payment in medical billing?</b>
            </h3>
            <p style={{ marginTop: "0px" }}>
              It ties payments to patient outcomes instead of service volume,
              promoting better care and cost efficiency.
            </p>
        
          </MDBCol>
          <MDBCol md="2" className="content" style={{ padding: "0px" }}>
            <MDBRow className="row-cols-1 row-cols-md-4 g-4">
              <MDBCol md="12">
                <MDBRow>
                  <MDBCard
                    className="cardtest1 p-0"
                    style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                  >
                    <MDBCardImage
                      src={BlogImg7}
                      alt="Obtain Billing Services from the Best Medical Billing
                  Company"
                      position="top"
                    />
                    <MDBCardBody>
                      <div
                        className="cardtitletest"
                        style={{
                          fontFamily: "Alegreya Sans",
                          fontWeight: "bold",
                        }}
                      >
                        <a href="obtain_billing_services_from_the_best_medical_billing_company">
                          Obtain Billing Services from the Best Medical Billing
                          Company
                        </a>
                      </div>
                      <MDBCardText>
                        <small className="text-muted">
                          AcerHealth | Aug - 2024
                        </small>
                      </MDBCardText>
                    </MDBCardBody>
                  </MDBCard>
                </MDBRow>
              </MDBCol>
              <MDBCol md="12">
                <MDBRow>
                  <MDBCard
                    className="cardtest1 p-0"
                    style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                  >
                    <MDBCardImage
                      src={BlogImg2}
                      alt="Choosing to Outsource Your Medical Billing is a Smart Decision?"
                      position="top"
                    />
                    <MDBCardBody>
                      <div
                        className="cardtitletest"
                        style={{
                          fontFamily: "Alegreya Sans",
                          fontWeight: "bold",
                        }}
                      >
                        <a href="choosing_to_outsource_your_medical_billing_is_a_smart_decision">
                          Choosing to Outsource Your Medical Billing is a Smart
                          Decision?
                        </a>
                      </div>
                      <MDBCardText>
                        <small className="text-muted">
                          AcerHealth | Aug - 2024
                        </small>
                      </MDBCardText>
                    </MDBCardBody>
                  </MDBCard>
                </MDBRow>
              </MDBCol>
              <MDBCol md="12">
                <MDBRow>
                  <MDBCard
                    className="cardtest1 p-0"
                    style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                  >
                    <MDBCardImage
                      src={BlogImg15}
                      alt="Management of the Healthcare Revenue Cycle"
                      position="top"
                    />
                    <MDBCardBody>
                      <div
                        className="cardtitletest"
                        style={{
                          fontFamily: "Alegreya Sans",
                          fontWeight: "bold",
                        }}
                      >
                        <a href="management_of_the_healthcare_revenue_cycle">
                          Management of the Healthcare Revenue Cycle
                        </a>
                      </div>
                      <MDBCardText className="pb-4">
                        <small className="text-muted">
                          AcerHealth | Aug - 2024
                        </small>
                      </MDBCardText>
                    </MDBCardBody>
                  </MDBCard>
                </MDBRow>
              </MDBCol>
              <MDBCol md="12">
                <MDBRow>
                  <MDBCard
                    className="cardtest1 p-0"
                    style={{ backgroundColor: "#f0f4fb", width: "300px" }}
                  >
                    <MDBCardImage
                      src={BlogImg16}
                      alt="Details about Patients is Protected by AcerHealth"
                      position="top"
                    />
                    <MDBCardBody>
                      <div
                        className="cardtitletest"
                        style={{
                          fontFamily: "Alegreya Sans",
                          fontWeight: "bold",
                        }}
                      >
                        <a href="details_about_patients_is_protected_by_acerhealth">
                          Details about Patients is Protected by AcerHealth
                        </a>
                      </div>
                      <MDBCardText className="pb-4">
                        <small className="text-muted">
                          AcerHealth | Aug - 2024
                        </small>
                      </MDBCardText>
                    </MDBCardBody>
                  </MDBCard>
                </MDBRow>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </div>
   <div className="row" style={{ paddingRight: "10%", paddingLeft: "5%" }}>
    <MDBRow className="row-cols-1 row-cols-md-4 g-4 mb-2">
              <MDBCol className="d-flex flex-column">
                <MDBCard
                  className="cardtest1"
                  style={{ backgroundColor: "#f0f4fb", height: "100%" }}
                >
                  <MDBCardImage
                    src={BlogImg7}
                    alt="Digital microchip representing advanced technology and data networks, symbolizing the future trends in medical billing and healthcare technology."
                    position="top"
                  />
                  <MDBCardBody className="d-flex flex-column">
                    <div
                      className="cardtitletest"
                      style={{
                        fontFamily: "Alegreya Sans",
                        fontWeight: "bold",
                      }}
                    >
                      <a href="obtain_billing_services_from_the_best_medical_billing_company">
                        Obtain Billing Services from the Best Medical Billing
                        Company
                      </a>
                    </div>
                    <MDBCardText>
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>

              <MDBCol className="d-flex flex-column">
                <MDBCard
                  className="cardtest1"
                  style={{ backgroundColor: "#f0f4fb", height: "100%" }}
                >
                  <MDBCardImage
                    src={BlogImg2}
                    alt="Choosing to Outsource Your Medical Billing is a Smart Decision?"
                    position="top"
                  />
                  <MDBCardBody className="d-flex flex-column">
                    <div
                      className="cardtitletest"
                      style={{
                        fontFamily: "Alegreya Sans",
                        fontWeight: "bold",
                      }}
                    >
                      <a href="choosing_to_outsource_your_medical_billing_is_a_smart_decision">
                        Choosing to Outsource Your Medical Billing is a Smart
                        Decision?
                      </a>
                    </div>
                    <MDBCardText>
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>

              <MDBCol className="d-flex flex-column">
                <MDBCard
                  className="cardtest1"
                  style={{ backgroundColor: "#f0f4fb", height: "100%" }}
                >
                  <MDBCardImage
                    src={BlogImg15}
                    alt="Management of the Healthcare Revenue Cycle"
                    position="top"
                  />
                  <MDBCardBody className="d-flex flex-column">
                    <div
                      className="cardtitletest"
                      style={{
                        fontFamily: "Alegreya Sans",
                        fontWeight: "bold",
                      }}
                    >
                      <a href="management_of_the_healthcare_revenue_cycle">
                        Management of the Healthcare Revenue Cycle
                      </a>
                    </div>
                    <MDBCardText>
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>

              <MDBCol className="d-flex flex-column">
                <MDBCard
                  className="cardtest1"
                  style={{ backgroundColor: "#f0f4fb", height: "100%" }}
                >
                  <MDBCardImage
                    src={BlogImg16}
                    alt="Details about Patients is Protected by AcerHealth"
                    position="top"
                  />
                  <MDBCardBody className="d-flex flex-column">
                    <div
                      className="cardtitletest"
                      style={{
                        fontFamily: "Alegreya Sans",
                        fontWeight: "bold",
                      }}
                    >
                      <a href="details_about_patients_is_protected_by_acerhealth">
                        Details about Patients is Protected by AcerHealth
                      </a>
                    </div>
                    <MDBCardText>
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
            </MDBRow>
   </div>



      </div>
      {/* <DownContact DownContactTitle={DownContactTitle} /> */}
    </>
  );
};

export default About;
